import { useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { fetchReferral } from "@/lib/api";
import ShareButton from "@/components/ShareButton";

// "Invite" = share the current page (with the user's referral code when signed in)
// so friends land here and the inviter earns referral credit on signup.
export default function InviteButton({ context = "Dharmartha", testid = "invite-button", variant = "button" }) {
  const { pick } = useLang();
  const { user } = useAuth();
  const en = pick("x", "y") === "y";
  const [code, setCode] = useState("");

  useEffect(() => { if (user) fetchReferral().then((r) => setCode(r.code || "")).catch(() => {}); }, [user]);

  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const pageUrl = typeof window !== "undefined" ? `${origin}${window.location.pathname}` : origin;
  const url = code ? `${origin}/register?ref=${code}` : pageUrl;
  const text = en ? `Join me on Dharmartha — ${context}` : `धर्मार्थ पर मेरे साथ जुड़ें — ${context}`;

  return (
    <ShareButton
      title={context}
      text={text}
      url={url}
      variant={variant}
      testid={testid}
      label={en ? "Invite" : "आमंत्रित करें"}
    />
  );
}
